import React from 'react'
import Section from '@/components/ui/Section'
import Button from '@/components/ui/Buttons/Button'
import { useOpenAuthenticationArticle, useOpenWebhook } from './WebhookSection.hooks'
import Typography from '@/components/ui/Typography'
import Alert from '@/components/ui/Alert'
import { ReactComponent as WarningIcon } from '@/assets/icons/warning.svg'
import { ReactComponent as WebhookIcon } from '@/assets/icons/connector.svg'
import classes from './WebhookSection.module.scss'
import Tag from '@/components/ui/Tag'
import { useWebhook } from '../../hooks/useWebhook'

export type Props = {
  projectId: number
  routeId: number
}

export const WebhookSection = ({ projectId, routeId }: Props) => {
  const { webhook, isLoading } = useWebhook(projectId, routeId)
  const openWebhook = useOpenWebhook(webhook?.id)
  const openAuthArticle = useOpenAuthenticationArticle()

  return (
    <Section className={classes.root}>
      <Section.Header title={'Webhook'} icon={<WebhookIcon />}>
        <Button variant={'soft'} disabled={isLoading} onClick={openWebhook}>
          Open in Admin Center
        </Button>
      </Section.Header>
      <Section.Content isLoading={isLoading}>
        {!isLoading && webhook && (
          <div className={classes.content}>
            <div className={classes.info}>
              <div>
                <Typography variant={'md'} isBold>
                  Name
                </Typography>
                <Typography variant={'md'}>{webhook.name}</Typography>
              </div>

              {webhook.status === 'active' ? <Tag color={'success'}>Active</Tag> : <Tag color={'danger'}>Inactive</Tag>}
            </div>

            {!webhook.authentication && (
              <Alert
                variant={'soft'}
                color={'warning'}
                startAdornment={<WarningIcon />}
                endAdornment={
                  <Button color={'warning'} variant={'soft'} onClick={openAuthArticle}>
                    How to?
                  </Button>
                }
              >
                Webhook is not protected with authentication. You need to set it up manually
              </Alert>
            )}
          </div>
        )}
      </Section.Content>
    </Section>
  )
}
